import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import {MdDehaze} from "react-icons/md";

export const MenuHeaderStyle = styled.h1`
  font-family: AvenirLTProBook, sans-serif;
  font-size: 19px;
  font-weight: 500;
  color: white;
  text-align: center;
  flex-grow: 1;

  @media only screen and (max-width: 600px) {
    font-size: 15px;
  }
`;

export const MenuDiv = styled.div`
  flex-grow: 1;
`;

export const StyledTypography = styled(Typography)`
  flex-grow: 1;
  text-align: center;
`;

export const MenuToolbar = styled(Toolbar)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const StyledButton = styled.button`
  text-transform: none;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  font: inherit;
  transition: color 0.3s ease;

  &:hover {
    color: var(--c5);
  }
`;

export const MenuWidth = styled.div`
  width: 300px;
`;

export const MenuItemContent = styled.div`
  display: flex;
  align-items: center;
  height: 55px;
  padding-left: 10px;
  &:hover {
    background-color: var(--background);
    border-radius: 8px;
  }
`;

export const MenuText = styled.div`
  font-size: 1.4rem;
  color: var(--menu-text);
`;

export const IconWrapper = styled.div`
  border: 1.2px solid var(--c5);
  border-radius: 19px;
  width: 55px;
  height: 39px;
  margin-right: 20px;
  color: var(--menu-text);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledHr = styled.hr`
  height: 14px;
  box-shadow: inset 0 4px 4px -4px var(--c1);
`;

export const StyledMenuIcon = styled(MdDehaze)`
  font-size: 2.5rem;
  color: white;
  transition: color 0.3s ease;

  &:hover {
    color: var(--c5);
  }
`;
